import Fade from '@mui/material/Fade';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight, TypographyStyledGlobal } from '../../../theme';
import { InputStyled } from '../../../theme/style';
import Title from '../../Title/title';
import BoxModalStyled from '../styled';
import ActionsButton from './actionButton';
import ColorSwatchBox from './ColorSwatchBox';
import { ColorSwatchCreationInterface, ColorSwatchModalProps } from './colorSwatchModalInterface';
import DeleteColorSwatchButton from './DeleteColorSwatchButton';
import { CloseIconModalStyled, FormControlStyled, ModalStyled } from './styled';

const ColorSwatchModal: FC<ColorSwatchModalProps> = ({ openModal, setOpenModal, handleUpdateColorSwatch, selectedColorSwatch, isEdit, handleDeleteColorSwatch }) => {
    const { t } = useTranslation(['common', 'settings']);
    const [configurateColorSwatch, setConfigurateColorSwatch] = useState<ColorSwatchCreationInterface>(selectedColorSwatch);
    const handleChangeColor = (colorIndex: number | undefined, color: string | undefined) => {
        if (!colorIndex || !color) {
            return;
        }
        setConfigurateColorSwatch((prev) => ({
            ...prev,
            colorSwatch: prev.colorSwatch.map((c: string, index: number) => (index === (colorIndex - 1) ? color : c)),
        }));
    };
    const handleClose = () => {
        setOpenModal(false);
    };
    const handleClickConfirm = () => {
        setOpenModal(false);
        handleUpdateColorSwatch(configurateColorSwatch);
    };

    useEffect(() => {
        setConfigurateColorSwatch(selectedColorSwatch);
    }, [selectedColorSwatch]);

    const handleChangeColorSwatchLabel = (event: ChangeEvent<HTMLInputElement>) => {
        setConfigurateColorSwatch((prev) => ({ ...prev, label: event.target.value }));
    };

    return (
        <ModalStyled
            aria-describedby="modal-modal-description"
            aria-labelledby="modal-modal-title"
            onClose={handleClose}
            open={openModal}
        >
            <Fade in={openModal}>
                <BoxModalStyled>
                    <Title content={isEdit ? t('settings:colorSwatches.modifyColorSwatch') : t('settings:colorSwatches.addColorSwatch')} />
                    <TypographyStyledGlobal
                        color={colors.grey200}
                        marginBottom={2}
                        size={fontSize.sm}
                        style={{ marginBottom: '0px' }}
                        weight={fontWeight.regular}
                    >
                        {isEdit ? t('settings:colorSwatches.renameColorSwatch') : t('settings:colorSwatches.nameColorSwatch') }
                    </TypographyStyledGlobal>
                    <InputStyled
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeColorSwatchLabel(e)}
                        placeholder={t('settings:colorSwatches.labelColorSwatchPlaceholder')}
                        style={{ width: '100%', marginTop: '2px' }}
                        value={configurateColorSwatch.label}
                    />
                    <FormControlStyled>
                        {configurateColorSwatch.colorSwatch.map((color: string, index: number) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <ColorSwatchBox key={index} color={color} colorIndex={index + 1} handleChangeColor={handleChangeColor} />
                        ))}
                    </FormControlStyled>
                    <CloseIconModalStyled onClick={handleClose} />
                    {isEdit && configurateColorSwatch.id && (
                        <DeleteColorSwatchButton colorSwatchId={configurateColorSwatch.id} handleDeleteColorSwatch={handleDeleteColorSwatch} label={t('settings:colorSwatches.deleteColorSwatch')} />
                    )}
                    <ActionsButton
                        buttonConfirmDisabled={configurateColorSwatch.label === undefined || configurateColorSwatch.label === ''}
                        handleClickCancel={handleClose}
                        handleClickConfirm={handleClickConfirm}
                        labelCancel={t('common:cancel')}
                        labelConfirm={t('common:validate')}
                    />
                </BoxModalStyled>
            </Fade>
        </ModalStyled>
    );
};

export default ColorSwatchModal;
